const textbox = require('./textBox');

module.exports = {
	...textbox,
	name: 'email',
	validation(yup) {
		return yup.string().email();
	}
};
